import { EquipPriceEnum } from '@/enums'
import type { EquipQuality } from '@/types/equip'

export function getEnchantPrice(quality: EquipQuality, enchantAttr: [number, number] | undefined) {
  let price = EquipPriceEnum[quality] * 500
  if (enchantAttr) {
    price *= enchantAttr[0] + 1
  }
  return price
}
export function getEnchantStone(enchantAttr: [number, number] | undefined) {
  return ((enchantAttr?.[0] || 0) + 1) * 5
}

export function getSeniorReinforceGoldPrice(reinforcedLevel: number) {
  let price = 1000000
  price *= reinforcedLevel - 14
  return price
}
export function getSeniorReinforceStonePrice(reinforcedLevel: number) {
  let price = 5
  price *= reinforcedLevel - 14
  return price
}
